<template>
    <div class="width100">
        <vue-confirm-dialog></vue-confirm-dialog>

        <b-modal id="modalAffichePanne" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title>
                Panne
            </template>
            <div class="d-block">
                <h5 class="text-center">{{panneTitre}}</h5>
                <div class="row">
                    <div class="col-3 text-center">
                        Date :
                    </div>
                    <div class="col-9 text-center">
                        {{panneDate}}
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-3 text-center">
                        Employé :
                    </div>
                    <div class="col-9 text-center">
                        {{panneUser}}
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-3 text-center">
                        Défaut :
                    </div>
                    <div class="col-9 text-center">
                        {{panneDefaut}}
                    </div>
                </div>
                <br />
                <div class="row" v-if="panneVu==1">
                    <div class="col-12 text-center text-info">
                        Cette panne est bien prise en compte, pour plus d'informations veillez vous rapprocher du bureau.
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-4 text-center">
                        Rendez vous réparation :
                    </div>
                    <div class="col-6" v-if="(userType=='admin' )">
                        <input type="date" class="form-control"  v-model="panneDateRendezVous">
                    </div>
                    <div class="col-6" v-else>
                        {{panneDateRendezVousFr}}
                    </div>
                    <div class="col-2" v-if="(userType=='admin' )">
                        <i class="fa-solid fa-circle-check fa-2x text-primary" @click="updateDateRendezVous()"></i>
                    </div>
                    <div class="col-12 text-center text-success" v-if="updateDateRDVOk==true">
                        Votre modification a bien été prise en compte.
                    </div>
                </div>
                <br />
                <p v-for="(photoDat, key) in photoData" :key="key">
                    <span v-html="photoDat"></span>
                </p>
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-danger" block @click="annulePanne()">Annuler</button>
                        &nbsp;
                        <button v-if="choix != 2" class="btn btn-primary" block @click="choixPanne()">Choisir</button>
                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal id="modalCorrection" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title>
                Correction <span v-if="machine!=null">{{machine.nom}}</span> -
                <span v-if="tache!=null">{{tache.intitule}}</span>
                <span v-if="panne!=null">{{panne.titre}}</span>

            </template>
            <div class="d-block">

                <div v-if="choixCorrect == 1" class="row">
                    <OperationFormulaire v-bind:token="token" v-bind:site="site"
                         v-bind:racine="racine" v-bind:user="user" v-bind:userId="userId"
                         v-bind:machine="machine" v-bind:tache="tache" @returnMaintenance="returnMaintenance"
                         v-bind:machineType="machineType" v-bind:idModif="idModif" v-bind:ifAppli="ifAppli"
                         @returnMaintenanceApresValide="returnMaintenanceApresValide"
                         v-bind:systemeClient="systemeClient"
                    ></OperationFormulaire>
                </div>
                <div v-if="choixCorrect == 2" class="row">
                    <PanneDeclarationFormulaire v-bind:token="token" v-bind:site="site"
                        v-bind:racine="racine" v-bind:user="user" v-bind:userId="userId"
                        v-bind:machine="machine" @returnMaintenance="returnMaintenance"
                        v-bind:machineType="machineType" v-bind:idModif="idModif" v-bind:ifAppli="ifAppli"
                        @returnMaintenanceApresValide="returnMaintenanceApresValide"
                        v-bind:systemeClient="systemeClient"
                    ></PanneDeclarationFormulaire>
                </div>
                <div v-if="choixCorrect == 3" class="row">
                    <PanneReparationFormulaire v-bind:token="token" v-bind:site="site" v-bind:machine="machine"
                       v-bind:racine="racine" v-bind:user="user" v-bind:userId="userId"
                       v-bind:panneId="panneId" v-bind:machineType="machineType"
                       @returnMaintenance="returnMaintenance" v-bind:idModif="idModif"  v-bind:ifAppli="ifAppli"
                       v-bind:panneIdModif="panneIdModif" @returnMaintenanceApresValide="returnMaintenanceApresValide"
                       v-bind:systemeClient="systemeClient"
                    ></PanneReparationFormulaire>
                </div>
                <br />
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-danger" block @click="annuleCorrection()">Annuler</button>

                    </div>
                </div>
            </div>
        </b-modal>

        <b-modal id="modalListMachinePasCharge" hide-footer
                 header-bg-variant="thtab"
                 header-text-variant="light">
            <template v-slot:modal-title class="text-center">
                {{ listMachinePasChargeTitre }}
            </template>
            <div class="d-block">
                <div class="d-block text-center listMachineNonCharge" v-html="listMachinePasCharge">
                    <h2>{{ listMachinePasCharge }}</h2>
                </div>
            </div>
        </b-modal>

        <Aide v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
              v-bind:user="user" v-bind:idAide="2"></Aide>

        <h3 class="titreSolu text-center">Maintenance </h3>
        <div>
            <h3 class="titreSolu text-center" v-if="niveau==1">Quelle opération faite vous ? </h3>
            <div v-if="niveau == 1 && (userType=='tech' || userType=='admin')" class="row" >
                <div v-for="(titre, keyTitre) in listTitre" :key="keyTitre" class="colSolu col-md-12 col-lg-4">
                    <div class="thtab userList col-12 text-center rounded"
                         @click="choixNiveau1(keyTitre)">
                        {{titre}}
                    </div>
                </div>
                <div v-if="listOperationHisto.length || listPanneHisto.length" class="colSolu col-md-12 col-lg-4">
                    <div class="thtabOrange userList col-12 text-center rounded" v-b-toggle="'collapse-histo'"
                         @click="afficherHisto()">
                        Correction
                    </div>
                </div>
            </div>
            <div v-if="niveau == 1 && userType=='user' " class="row" style="margin-top: 45px;">
                <div v-for="(titre, keyTitre) in listTitre" :key="keyTitre" class="colSolu col-md-12 col-lg-6">
                    <div class="thtab userList col-12 text-center rounded"
                         @click="choixNiveau1(keyTitre)">
                        {{titre}}
                    </div>
                </div>
                <div v-if="listOperationHisto.length || listPanneHisto.length" class="colSolu col-md-12 col-lg-4">
                    <div class="thtabOrange userList col-12 text-center rounded" v-b-toggle="'collapse-histo'"
                         @click="afficherHisto()">
                        Correction
                    </div>
                </div>
            </div>


            <div v-if="niveau > 1" class="row" >
                <div class="col-12 text-center">
                    <h3>{{titreOperation}}</h3>
                </div>
            </div>

            <h3 class="titreSolu text-center" v-if="niveau==2">De quel type de machine s'agit il?</h3>
            <div v-if="niveau == 2" class="row" style="overflow: scroll;height:250px;">
                <div v-for="(machineType, keyMachineT) in listMachineType" :key="keyMachineT" class="colSolu col-md-12 col-lg-4">
                    <div class="thtab userList col-12 text-center rounded"
                         @click="choixMachineType(keyMachineT)">
                        {{machineType.intitule}}
                    </div>
                </div>
            </div>

            <h3 class="titreSolu text-center" v-if="niveau==3">De quelle machine il s'agit ?</h3>
            <p class="text-center text-warning" v-if="niveau==3">Cette liste est classée par votre fréquence d'utilisation.</p>
            <div v-if="niveau == 3" class="row" style="overflow: scroll;height:250px;">
                <div v-for="(machine, keyMachine) in listMachine" :key="keyMachine" class="colSolu col-md-12 col-lg-4">
                    <div v-if="machineType['@id'] == machine.typeMachine" class="thtab userList col-12 text-center rounded"
                         @click="choixMachine(keyMachine)">
                        {{machine.nom}}
                    </div>
                </div>
            </div>

            <div v-if="niveau > 3" class="row">
                <div class="col-12 text-center">
                    <h3>{{machine.nom}}</h3>
                </div>
            </div>
            <div v-if="niveau == 4">

                <h3 class="titreSolu text-center" v-if="choix == 1" ref="other"> Quelle tâche accomplissez vous ? </h3>
                <div v-if="choix == 1">
                    <div class="row" style="overflow: scroll;height:250px;">
                        <div v-for="(tache, keyTache) in listTache" :key="keyTache" class="colSolu col-md-12 col-lg-4">
                            <div v-if="tache.intitule.toLowerCase().includes(keywords.toLowerCase()) || keywords == null" class="thtab userList col-12 text-center rounded"
                                 @click="choixTache(keyTache)">
                                {{tache.intitule}}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-9 offset-1">
                            <input type="text" ref="champFiltre" class="form-control"  v-model="keywords" placeholder="Rechercher"/>

                        </div>
                        <div class="col-1">
                            <i class="fa-solid fa fa-chevron-right fa-2x text-primary"></i>
                        </div>
                    </div>
                </div>
                <div v-if="choix == 2">
                    <h3 class="titreSolu text-center" > Pannes déjà déclarées </h3>
                    <div class="row" >
                        <div class="colSolu col-md-12 col-lg-4">
                            <div class="thtabOrange userList col-12 text-center rounded"
                                 @click="nouvelleDeclarationPanne()">
                                Nouvelle panne
                            </div>
                        </div>
                        <div v-for="(panne, keyPanne) in listPanne" :key="keyPanne" class="colSolu col-md-12 col-lg-4">
                            <div class="thtab userList col-12 text-center rounded"
                                 @click="affichePanne(keyPanne)">
                                {{panne.titre.substring(0, 20)}} <i v-if="panne.vu == 1" class="fa-solid fa fa-check text-warning"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="choix == 3">
                    <div class="row" >
                        <div class="colSolu col-md-12 col-lg-4">
                            <div class="thtabOrange userList col-12 text-center rounded"
                                 @click="nouvellePanne()">
                                Nouvelle panne
                            </div>
                        </div>
                        <div v-for="(panne, keyPanne) in listPanne" :key="keyPanne" class="colSolu col-md-12 col-lg-4">
                            <div class="thtab userList col-12 text-center rounded"
                                 @click="affichePanne(keyPanne)">
                                {{panne.titre.substring(0, 20)}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div v-if="niveau > 4 && choix == 1" class="row">
                <div class="col-12 text-center">
                    <h3>{{tache.intitule}}</h3>
                </div>
            </div>

            <div v-if="niveau == 5">
                <div v-if="choix == 1" class="row">
                    <OperationFormulaire v-bind:token="token" v-bind:site="site"
                        v-bind:racine="racine" v-bind:user="user" v-bind:userId="userId"
                         v-bind:machine="machine" v-bind:tache="tache" @returnMaintenance="returnMaintenance"
                         v-bind:machineType="machineType" v-bind:idModif="idModif" v-bind:ifAppli="ifAppli"
                         @returnMaintenanceApresValide="returnMaintenanceApresValide"
                         v-bind:systemeClient="systemeClient"
                    ></OperationFormulaire>
                </div>
                <div v-if="choix == 2" class="row">
                    <PanneDeclarationFormulaire v-bind:token="token" v-bind:site="site"
                        v-bind:racine="racine" v-bind:user="user" v-bind:userId="userId"
                        v-bind:machine="machine" @returnMaintenance="returnMaintenance"
                        v-bind:machineType="machineType" v-bind:idModif="idModif" v-bind:ifAppli="ifAppli"
                        @returnMaintenanceApresValide="returnMaintenanceApresValide"
                        v-bind:systemeClient="systemeClient"
                    ></PanneDeclarationFormulaire>
                </div>
                <div v-if="choix == 3" class="row">
                    <PanneReparationFormulaire v-bind:token="token" v-bind:site="site" v-bind:machine="machine"
                        v-bind:racine="racine" v-bind:user="user" v-bind:userId="userId" v-bind:panneId="panneId"
                        v-bind:machineType="machineType" v-bind:idModif="idModif" v-bind:panneIdModif="panneIdModif"
                        v-bind:ifAppli="ifAppli"
                       @returnMaintenance="returnMaintenance" @returnMaintenanceApresValide="returnMaintenanceApresValide"
                       v-bind:systemeClient="systemeClient"
                    ></PanneReparationFormulaire>
                </div>
                <div v-if="choix == 4" class="row">
                    <PanneHistorique v-bind:token="token" v-bind:site="site" v-bind:machine="machine"
                        v-bind:racine="racine" v-bind:user="user" v-bind:userId="userId" v-bind:panneId="panneId"
                        v-bind:machineType="machineType" v-bind:idModif="idModif" v-bind:panneIdModif="panneIdModif"
                        v-bind:ifAppli="ifAppli"
                       @returnMaintenance="returnMaintenance" @returnMaintenanceHistoPanne="returnMaintenanceHistoPanne"
                       v-bind:systemeClient="systemeClient"
                    ></PanneHistorique>
                </div>
            </div>

            <div v-if="niveau>1 && niveau!=5" class="text-center">
                <br />
                <button class="btn btn-danger" block @click="returnNiveau()">Retour</button>
            </div>

            <!-- histo/correction -->
            <div v-if="niveau == 1 && afficheHisto==1">
                <br />
                <b-collapse :id="'collapse-histo'" class="mt-2">
                    <b-card class="width100 padding0">
                        <h4>Liste des actions du jour</h4>
                        <div class="row">
                            <div v-for="(op, keyOp) in listOperationHisto" :key="keyOp" class="colSolu col-md-12 col-lg-6">
                                <div class="thtabBlue userList col-12 text-center rounded"
                                     @click="choixCorrectionOp(keyOp,op.typeAction,op)">
                                    {{op.machine.nom}} -
                                    <span v-if="op.tache!=null">{{op.tache.intitule}}</span>
                                    <span v-if="op.panne!=null">{{op.panne.titre}}</span>
                                </div>
                            </div>
                        </div>
                    </b-card>
                </b-collapse>
            </div>

            <div v-if="niveau == 1 && systemeClientId == 1">
                <br />
                <button class="btn btn-info" block @click="getListMachinePasCharge()">Chariots à vérifier la charge</button>
            </div>

            <div id="idScrollObjectif"></div>
            <p style="margin-bottom: 100px">&nbsp;</p>
        </div>
    </div>
</template>

<script>
    import OperationFormulaire from './OperationFormulaire.vue';
    import PanneDeclarationFormulaire from './PanneDeclarationFormulaire.vue';
    import PanneReparationFormulaire from './PanneReparationFormulaire.vue';
    import PanneHistorique from './PanneHistorique.vue';
    import Aide from './Aide';
    import VueScrollTo from "vue-scrollto";

    export default {
        name: "Maintenance",
        props: ['token', 'site', 'user', 'racine','listUser', 'userId','userType','idUser','systemeClient','systemeClientId'
                ,'ifAppli'],
        data() {
            return {
                aide: '',errors: [], listMachine :null, listTache:null,listPanne:null,
                choix:0, niveau:1, titreOperation:null, listTitre :{1:'Entretien standard',2:'Déclarer Panne',3:'Réparer Panne',4:'Historique panne'},
                panne:null,tache:null, panneDefaut:null, panneUser:null,panneDate:null,panneTitre:null,panneVu:null,
                machine:null,panneId:null, filtreStr:'',keywords: '',
                dateToday:null,
                imagePath:null,blob:null,dataUrl:null,
                photoData:[],listMachineType:null,machineType:null,
                listOperationHisto:[],listPanneHisto:[],afficheHisto:0,choixCorrect:null,idModif:null,
                panneIdModif:null, listMachinePasCharge:null,panneDateRendezVous:null,updateDateRDVOk:false
                ,panneDateRendezVousFr:null
            };
        },
        methods: {
            tokenValide(json) {
                if (json['status'] == '401') {
                    this.$emit('token')
                }
            },
            memChrono()
            {
                var self = this
                this.$nextTick(() => this.$refs.other.focus())
                //this.$nextTick(() => this.$refs.champFiltre.focus())
                setInterval(() => {
                    //self.$refs.input.$el.other.focus()
                    //this.$refs.champFiltre.focus()
                    console.log(self.$refs.champFiltre.focus())
                    console.log(self.keywords)
                    console.log(self.keywords.toLowerCase())
                    self.filtreStr = self.keywords.toLowerCase()
                }, 500)
            },
            queryForKeywords(event)
            {
                console.log(event.target.value)
                console.log(this.keywords)
                this.filtreStr = this.keywords
                //this.filtreStr = event.target.value
            },
            returnNiveau()
            {
                if(this.niveau>1)
                {
                    this.niveau--
                }

                /*if(this.choix == 2 && this.niveau == 3)
                {
                    this.niveau--
                }*/
            },
            choixNiveau1(keyTitre)
            {
                this.afficheHisto = 0
                this.idModif = null
                this.niveau = 2
                this.titreOperation = this.listTitre[keyTitre]
                if(keyTitre==1)
                {
                    this.choix = 1
                    /*if(this.userType=='tech' || this.userType=='admin')
                    {
                        this.getTaches()
                    }
                    else
                    {
                        this.getTachesNiv(1)
                    }*/
                }
                else if(keyTitre==2)
                {
                    this.choix = 2
                }
                else if(keyTitre==3)
                {
                    this.choix = 3
                }
                else if(keyTitre==4)
                {
                    this.choix = 4
                }

            },
            choixTache(key)
            {
                this.niveau = 5
                this.tache = this.listTache[key]
            },
            affichePanne(key)
            {
                this.photoData = []
                this.panne = this.listPanne[key]
                this.panneDefaut = this.panne.defaut
                this.panneId = this.panne.id
                console.log(this.listUser)
                console.log(this.panne.user.name)
                this.panneUser = this.panne.user.name
                console.log(this.panneUser)
                this.panneTitre = this.panne.titre
                this.panneVu = this.panne.vu

                var today = new Date(this.panne.date)
                var month = today.getMonth() + 1
                var day = today.getDate()
                if (month < 10) {
                    month = "0" + month
                }
                if (day < 10) {
                    day = "0" + day
                }
                this.panneDate = day+ '/' + month+'/'+today.getFullYear()

                var todayRDV = new Date(this.panne.dateRendezVous)
                var monthRDV = todayRDV.getMonth() + 1
                var dayRDV = todayRDV.getDate()
                if (monthRDV < 10) {
                    monthRDV = "0" + monthRDV
                }
                if (dayRDV < 10) {
                    dayRDV = "0" + dayRDV
                }
                this.panneDateRendezVous = todayRDV.getFullYear()+'-'+monthRDV+'-'+dayRDV
                this.panneDateRendezVousFr = dayRDV+ '/' + monthRDV+'/'+todayRDV.getFullYear()
                this.$bvModal.show('modalAffichePanne')

                fetch(this.racine + this.site + 'api/get_photo_panne/'+this.panneId, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    }
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            //this.listPanne = json['hydra:member']
                            this.photoData = json['img']
                        }
                    })
                })
            },
            choixPanne(key)
            {
                this.niveau = 5
                this.panne = this.listPanne[key]
                this.$bvModal.hide('modalAffichePanne')
            },
            annulePanne()
            {
                this.photoData = []
                this.$bvModal.hide('modalAffichePanne')

                this.photoData = []
                this.blob = null
                this.dataUrl = null
                this.imagePath = null
            },
            choixMachine(key)
            {
                this.machine = this.listMachine[key]
                this.niveau = 4

                if(this.choix == 3)
                {
                    this.getPannes()
                }

                if(this.choix == 2)
                {
                    //this.niveau = 4
                    this.getPannes()
                }

                if(this.choix == 4)
                {//si histo on passe à la suite
                    this.niveau = 5
                }
            },
            choixMachineType(keyMT)
            {
                this.machineType = this.listMachineType[keyMT]
                this.niveau = 3
                this.getMachines()
                this.getTaches()
            },
            getPannes()
            {
                fetch(this.racine + this.site + 'api/pannes?machine='+this.machine.id+"&resolu=0"+'&systemeClient='+this.systemeClient, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listPanne = json['hydra:member']
                        }
                    })
                })
            },
            getMachines()
            {
                fetch(this.racine + this.site + 'api/get_machine_by_frequence_operation/'+this.idUser+'/'+this.systemeClientId+'/'+this.machineType['id'], {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listMachine = json['hydra:member']
                        }
                    })
                })
            },
            getTaches()
            {
                fetch(this.racine + this.site + 'api/taches?typeMachine='+this.machineType['@id']+'&systemeClient='+this.systemeClientId, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listTache = json['hydra:member']
                        }
                    })
                })
            },
            getTachesNiv(niv)
            {
                fetch(this.racine + this.site + 'api/taches?niveau='+niv+'&systemeClient='+this.systemeClientId, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listTache = json['hydra:member']
                        }
                    })
                })
            },
            returnMaintenance()
            {
                this.returnNiveau()
                if(this.choix == 2 || this.choix == 3) {
                    this.getPannes()
                }
            },
            returnMaintenanceHistoPanne()
            {
                this.returnNiveau()
                this.returnNiveau()
            },
            returnMaintenanceApresValide()
            {
                this.choix = 0
                this.niveau = 1
                this.photoData = []
                this.blob = null
                this.dataUrl = null
                this.imagePath = null
                this.getHisto()
                this.$bvModal.hide('modalCorrection')
            },
            nouvellePanne()
            {
                this.panneId = null
                this.panneDefaut = null

                this.panneUser = null

                this.panneTitre = null

                var today = new Date()
                var month = today.getMonth() + 1
                var day = today.getDate()
                if (month < 10) {
                    month = "0" + month
                }
                if (day < 10) {
                    day = "0" + day
                }
                this.panneDate = day+ '/' + month+'/'+today.getFullYear()

                this.niveau = 5
            },
            nouvelleDeclarationPanne()
            {
                this.$bvModal.msgBoxConfirm("Etes vous sûr que votre panne n'existe pas déjà ?", {
                    title: 'Etes vous sûr?',
                    size: 'lg',
                    buttonSize: 'lg',
                    okVariant: 'danger',
                    okTitle: 'Oui',
                    cancelTitle: 'Non',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                    noFade: true
                })
                .then(value => {
                    if (value == true) {
                        this.niveau = 5
                    }})



            },
            getMachineTypes()
            {
                fetch(this.racine + this.site + 'api/machine_types?systemeClient='+this.systemeClientId, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listMachineType = json['hydra:member']
                        }
                    })
                })
            },
            getHisto()
            {

                fetch(this.racine + this.site + 'api/get_operation_panne_today/'+this.idUser+'/'+this.dateToday, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listOperationHisto = json['list']
                        }
                    })
                })
            },
            afficherHisto()
            {
                if(this.afficheHisto == 1)
                {
                    this.afficheHisto = 0
                }
                else
                {
                    this.afficheHisto = 1
                }
                VueScrollTo.scrollTo('#idScrollObjectif', 1000 )
            },
            choixCorrectionOp(idOp,typeAction,data)
            {
                console.log(data)
                console.log(data.machine)

                this.$bvModal.show('modalCorrection')
                this.choixCorrect = typeAction
                this.machine = data.machine
                this.tache = data.tache
                this.panne = data.panne
                this.machineType = data.machineType
                this.idModif = data.id
                if(typeAction==3)
                {
                    this.panneIdModif = data.panne.id
                }
            },
            annuleCorrection()
            {
                this.$bvModal.hide('modalCorrection')
                this.choixCorrect = null
                this.machine = null
                this.tache = null
                this.panne = null
                this.machineType = null
                this.idModif = null
                this.panneIdModif = null
            },
            getListMachinePasCharge()
            {
                fetch(this.racine + this.site + 'api/get_list_machine_pas_charge/'+this.systemeClientId, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                }).then(response => {
                    this.tokenValide(response)
                    console.log(response)
                    response.json().then(json => {
                        if (json != undefined) {
                            console.log(json)
                            this.listMachinePasCharge = json['text']
                            this.listMachinePasChargeTitre = json['titre']
                            this.$bvModal.show('modalListMachinePasCharge')
                        }
                    })
                })
            },
            updateDateRendezVous()
            {

                fetch(this.racine + this.site + 'api/save_date_rendez_vous/'+this.panneId, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.token
                    },
                    body: "{\"dateRendezVous\":\"" + this.panneDateRendezVous + "\"" +
                    "}"
                }).then(response => response.json())
                    .then(json => {
                        console.log(json);
                        this.updateDateRDVOk = true
                        var self = this
                        setTimeout(function () {
                            self.updateDateRDVOk = false
                        }, 5000)
                    })
            }

        },
        mounted() {
            var today = new Date()
            var month = today.getMonth() + 1
            var day = today.getDate()
            if (month < 10) {
                month = "0" + month
            }
            if (day < 10) {
                day = "0" + day
            }
            this.dateToday = today.getFullYear()+ '-' + month+'-' + day
            this.getMachineTypes()
            //this.getTaches()
            this.getTachesNiv(1)
            this.getHisto()
            if(this.userType == 'user')
            {
                this.listTitre = {1:'Entretien standard',2:'Déclarer Panne'}
                if(this.systemeClientId == 2)
                {
                    this.listTitre = {2:'Déclarer Panne/sinistre',4:'Historique panne'}
                }
            }
        },
        created() {
            //window.addEventListener('keyup', this.myMethod)

        },
        components: {
            OperationFormulaire,
            PanneDeclarationFormulaire,
            PanneReparationFormulaire,
            PanneHistorique,
            Aide,
        }
    }
</script>

<style scoped>
    .userList {
        padding: 5px;
        /*margin-left: 2px;
        margin-right: 2px;
        margin-top: 5px;*/
        border: 2px white solid;
        font-size: 28px;
    }
    .listMachineNonCharge
    {
        font-size: 28px;
    }
</style>